import { withStyles } from "@material-ui/core/styles";
import Navbar from "./Navbar";
import styles from "./styles";
import withPrograma from "js/hoc/withPrograma";
import { compose } from "recompose";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import { withNotificationContext } from "js/notification-context";

const enhance = compose(
  withPrograma,
  withNotificationContext,
  withStyles(styles),
  withApollo,
  withRouter
);
export default enhance(Navbar);
